module.exports = {
    APP_NAME: 'MMFORM',
    API_URL: 'https://app.mmform.com/api/v1',
    VUEX_KEY: 'APP.MMFORM.VUEX',
    GOOGLE_ANALYTICS: 'G-HL6CXEBWE1',
}

